import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { StateModalPage } from './state-modal.page';

const routes: Routes = [
  {
    path: '',
    component: StateModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StateModalPageRoutingModule {}
